var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdditionIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 1.375V8.875H18.625C19.2344 8.875 19.75 9.39062 19.75 10C19.75 10.6562 19.2344 11.125 18.625 11.125H11.125V18.625C11.125 19.2812 10.6094 19.75 10 19.75C9.34375 19.75 8.875 19.2812 8.875 18.625V11.125H1.375C0.71875 11.125 0.25 10.6562 0.25 10C0.25 9.39062 0.71875 8.875 1.375 8.875H8.875V1.375C8.875 0.765625 9.34375 0.25 10 0.25C10.6094 0.25 11.125 0.765625 11.125 1.375Z",
    fill: "#38539A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionIconBlue);
export default __webpack_public_path__ + "static/media/addition_icon_blue.fb3166a2067874d2dac465edfd45e457.svg";
export { ForwardRef as ReactComponent };